import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    modify: {
        id: "general.modify",
    },
});

export default messages;
